import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Container = styled.div`
  background-color: ${(props) => props.bgColor || props.theme.blueDark};
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  padding: 20px;
  text-align: center;
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: 0.25px;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 20;
  font-family: 'FilsonPro';
  @media (max-width: ${breakpoints.s}px) {
    background-color: ${(props) => props.bgColor};
    padding: 15px 16px;
    font-size: 16px;
    letter-spacing: 0.06px;
    text-align: center;
    line-height: 1.3;
  }
  span {
    color: ${(props) => props.boldSpanColor || props.theme.coral};
    text-decoration: ${(props) => (props.boldSpanUnderline ? 'underline' : 'none')};
  }
  p {
    color: ${(props) => props.textColor || props.theme.emerald};
  }
`

export const Text = styled.p`
  color: ${(props) => props.textcolor || 'white'};
  margin: 0;
  font-family: 'FilsonProBook';
  z-index: 3;
  b {
    font-family: 'FilsonProBold';
  }
  @media (max-width: 500px) {
    font-size: 13px;
    width: 80%;
    margin: auto;
  }
`

export const CalLink = styled(Link)`
  color: ${(props) => props.color || props.theme.blueLight};
  font-family: 'FilsonProBold';
  text-decoration: underline;
`
export const ALink = styled.a`
  color: ${(props) => props.color || props.theme.grayDark};
  font-family: 'FilsonProBold';
  text-decoration: underline;
`

export const BannerContent = styled.div`
  color: ${(props) => props.textcolor};
  margin: 0;
  font-family: 'FilsonProBook';
  z-index: 3;
  p {
    margin: 0;
    font-weight: 300;
    font-family: 'FilsonProBook';
  }
  b {
    font-family: 'FilsonProBold';
  }
  a {
    color: rgb(220, 241, 243);
    font-family: FilsonProBold;
    text-decoration: underline;
    color: ${(props) => props.linkColor};
  }
  @media (max-width: 500px) {
    font-size: 13px;
  }
`
export const HolidayImage = styled(GatsbyImage)`
  position: absolute !important;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
`
